import { jsx as _jsx } from "react/jsx-runtime";
import { SkillBuilderRemote } from 'components/pages/skill-builder-remote';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';
export const skillBuilderRoutes = [
    {
        path: ROUTE_PATHS.SKILL_BUILDER,
        children: [
            {
                index: true,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(SkillBuilderRemote, {})
                })
            },
            {
                path: ROUTE_PATHS.MATCH_ALL,
                element: /*#__PURE__*/ _jsx(SecureRoute, {
                    children: /*#__PURE__*/ _jsx(SkillBuilderRemote, {})
                })
            }
        ]
    }
];
